import React, { useState } from "react";
import { authApi } from "./api";
import { Alert, Box, Button, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import LockRoundedIcon from "@mui/icons-material/LockRounded";

export default function PasswordReset({ token, onDone }) {
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError("");
    if (password.length < 8) return setError("Das Passwort muss mindestens 8 Zeichen lang sein.");
    if (password !== repeat) return setError("Die Passwörter stimmen nicht überein.");
    setSaving(true);
    try {
      const data = await authApi.resetPassword(token, password);
      onDone(data.message);
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 460, mx: "auto", p: { xs: 2.5, sm: 4 }, borderRadius: 3, boxShadow: "0 18px 50px rgba(17,54,75,.14)", border: "1px solid rgba(18,79,123,.08)", borderTop: "5px solid #f3cf19", bgcolor: "#fff", mb: 3 }}>
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <Typography variant="h5">Neues Passwort festlegen</Typography>
        <Typography color="text.secondary" sx={{ mt: .5, fontSize: 14 }}>Mindestens 8 Zeichen. Danach kannst du dich mit dem neuen Passwort anmelden.</Typography>
      </Box>
      <Stack spacing={2}>
        <TextField
          label="Neues Passwort"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          fullWidth
          required
          InputProps={{ startAdornment: <InputAdornment position="start"><LockRoundedIcon color="primary" fontSize="small" /></InputAdornment> }}
        />
        <TextField
          label="Passwort wiederholen"
          type="password"
          autoComplete="new-password"
          value={repeat}
          onChange={e => setRepeat(e.target.value)}
          fullWidth
          required
          InputProps={{ startAdornment: <InputAdornment position="start"><LockRoundedIcon color="primary" fontSize="small" /></InputAdornment> }}
        />
        <Button type="submit" variant="contained" size="large" fullWidth disabled={saving}>
          {saving ? "Speichert …" : "Passwort speichern"}
        </Button>
        <Button variant="text" fullWidth onClick={() => onDone("")}>Zurück zum Login</Button>
      </Stack>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </Box>
  );
}
